import React, { Component } from "react";
import { connect } from 'react-redux';

import { fetchDevices, updateDevice } from "../actions/api"
import Table from './table';
import {
  faCheck,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderToString } from "react-dom/server";
class Devices extends Component {
  constructor(props) {
    super(props);
    this.state = { devices: null };
  }
  tableSchema = [
    {
      title: 'Device Id',
      defaultContent: "N/A",
      // width: 120,
      data: 'device_id'
    },
    {
      title: 'Created at',
      defaultContent: "N/A",
      // width: 180,
      data: 'created_at'
    },
    {
      title: 'Approved at',
      defaultContent: "N/A",
      // width: 180,
      data: 'approved_at'
    },
    {
      title: 'Otp',
      defaultContent: "N/A",
      // width: 180,
      data: 'device_otp'
    },
    {
      title: 'Approved',
      defaultContent: "N/A",
      // width: 180,
      data: 'approved'
    },
    {
      title: "Actions",
      data: null,
      defaultContent: renderToString(
        <Container>
          <Row className="clearfix">
            <Col>
              <button title="Approve" className="btn btn-success mr-1 approveDevice" disabled={!this.props.permissions.includes('ADMIN')}>
                <FontAwesomeIcon className="mr-1 ml-1" icon={faCheck} />
              </button>
            </Col>
            <Col>
              <button title="Deny" className="btn btn-danger denyDevice" disabled={!this.props.permissions.includes('ADMIN')}>
                <FontAwesomeIcon className="mr-1 ml-1" icon={faTimes} />
              </button>
            </Col>
          </Row>
        </Container >),
      ordering: false
    },

  ];
  // constructor(props) {
  //   super(props);
  //   };

  // }
  componentDidMount() {
    if (!this.props.devices)
      this.props.fetchDevices();
  }
  handleClick(payload, status) {
    const requestPayload = {
      otp: payload.device_otp,
      approved: status
    }
    this.props.updateDevice(requestPayload);
  }
  tableBTNTasks = [{
    className: 'approveDevice',
    task: (event) => this.handleClick(event, true)
  },
  {
    className: 'denyDevice',
    task: (event) => this.handleClick(event, false)
  }];

  render() {
    console.log(this.state.devices);
    const devices = this.props.devices || [];
    return (
      <div className="container-fluid">
        <div className="row align-items-center" >
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Table data={devices} schema={this.tableSchema} buttonTasks={this.tableBTNTasks} />
          </div>
        </div>
      </div >
    );
  }
}

// export default Users;
const mapStateToProps = ({ reducer: store }) => {
  return {
    devices: store.devices,
    permissions: store.user.permissions
  };
};
export default connect(mapStateToProps, { fetchDevices, updateDevice })(Devices);
